<template>
  <div>
    <div class="changePhoneNumber">
      <div class="title">
        <p>修改注册邮箱</p>
      </div>
      <div class="contair">
        <el-steps :active="stepNumber">
          <el-step title="步骤 1" description="验证身份"></el-step>
          <el-step title="步骤 2" description="修改邮箱"></el-step>
          <el-step title="步骤 3" description="完成"></el-step>
        </el-steps>
        <div class="lines"></div>
        <div v-if="stepNumber===1">
          <div class="stepOne">
            <p class="tips"><i class="iconfont icon-gantanhao"></i>&nbsp;&nbsp;为确认是您本人操作，请完成以下验证</p>
            <div class="phoneNumber">
              <div class="leftbox">
                <p>已验证手机：</p>
              </div>
              <div class="rightbox">
                <p>{{oldMobileShow}}</p>
              </div>
            </div>

            <div class="phoneInput">
              <div class="leftbox">
                <p>短信验证码：</p>
              </div>
              <div class=" message">
                <el-form :model="verificationCodeForm" status-icon :rules="rules" ref="verificationCodeForm" >
                  <el-form-item prop="verificationCode">
                   <el-input v-model.trim="verificationCodeForm.verificationCode"></el-input>
                  </el-form-item>
                </el-form>
                <div class="sendMessageDisabled" v-if="countdownClickDisabled">
                  {{verificationMsg}}
                </div>
                <div class="sendMessage" @click="getVerificationCode" v-else>
                  {{verificationMsg}}
                </div>
                <!-- <div class="noSend">没收到短信验证码？</div> -->
              </div>
            </div>

            <div class="btnBox">
              <div class="leftbox"></div>
              <button class="nextButton" @click="toNextStep(2)">下一步</button>
            </div>
          </div>
        </div>
        <div v-if="stepNumber===2">
          <div class="stepOne">
           <div class="phoneNumber">
              <div class="leftbox">
                <p>原邮箱：</p>
              </div>
              <div class="rightbox">
                <p>{{oldMobile}}</p>
              </div>
            </div>

           <div class="phoneInput">
             <div class="leftbox">
               <p>新邮箱：</p>
             </div>
              <div class="message">
                <el-form :model="mobileForm" status-icon :rules="rules" ref="mobileForm" >
                  <el-form-item prop="newEmail">
                   <el-input v-model.trim="mobileForm.newEmail" placeholder="新邮箱"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>

            <div class="btnBox">
              <div class="leftbox"></div>
              <button class="nextButton" @click="toNextStep(3)">下一步</button>
            </div>
          </div>
        </div>
        <div v-if="stepNumber===3">
          <div class="stepOne">
           <div class="phoneNumber">
              <div class="leftbox">
              </div>
              <div class="rightbox">
                <p>恭喜完成邮箱修改</p>
              </div>
            </div>

            <div class="btnBox">
              <div class="leftbox"></div>
              <router-link :to="{name:'personalInformation'}" class="nextButton">完成</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import qs from 'qs'
  export default ({
    name: 'changeMobile',
    comments: {},
    data() {
      var checkEmail = (rule, value, callback) => {
        var regEmail=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

        if (value === '') {
          callback(new Error('请输入邮箱'));
        } else if (!regEmail.test(value)) {
          callback(new Error('邮箱格式不正确，请重新填写'));
        } else {
          //校验手机号在本系统是否已注册
          this.validateInfo({
            "email": value,
            "validateMobile": true
          }, callback);
        }
      };

      var checkVerificationCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          if (this.countdownTime < 0) {
            callback(new Error('验证码超时'));
          } else {
            //校验验证码是否正确
            this.validateInfo({
              "verificationCode": value,
              "mobile": this.oldMobile
            }, callback);
          }
        }
      };
      return {
        stepNumber: 1,//步骤
        oldMobile: sessionStorage.getItem('mobile'), //修改前手机号码
        oldMobileShow:'',//显示的旧手机号码
        verificationMsg: '获取验证码',
        countdownTime: this.$store.state.defaultCountdownTime, //倒计时秒
        countdownClickDisabled: false, //验证码发送控制  false:可点击   true:不可点击
        verificationCodeForm: {
          verificationCode: ''
        },
        mobileForm: {
          newEmail: ''//修改后的邮箱
        },
        rules: { //验证
          newEmail: [{
            validator: checkEmail,
            trigger: 'blur'
          }],
          verificationCode: [{
            validator: checkVerificationCode,
            trigger: 'blur'
          }]
        }
      }
    },

    mounted() {
      if(this.oldMobile && this.oldMobile!==''){
        this.changPhoneNumber(this.oldMobile)
      }
    },
    methods: {
      //隐藏4位号码
      changPhoneNumber(number){
         this.oldMobileShow =  number.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")
      },
      toNextStep(number) {
        if (number == 2) {
          this.$refs['verificationCodeForm'].validate((valid) => {
            if (valid) {
               this.stepNumber=number;
            } else {
              console.log('验证码错误!!');
              this.stepNumber = number-1;
              return false;
            }
          });
        } else if (number == 3) {
          this.$refs['mobileForm'].validate((valid) => {
            if (valid) {

              let this_ = this;
              let  data_ = {
                  "userId": this_.$store.state.userId,//默认用户id
                  "email":this_.mobileForm.newEmail ,//新邮箱
                  "nickname": this_.$store.state.user,
                  "client": this_.$store.state.defaultClient,
                  "clientSys": this_.$store.state.defaultClientSys,
                  "systemcode":this_.$store.state.systemcode //系统编号
                };
              let paramdata = {};
              paramdata.url = '/jwt/user/saveEmail';
              paramdata.data = data_; //json对象
              paramdata.onSuccess = function(res) {
                if (res.data.ok) {
                  this_.stepNumber=number;
                } else {
                  let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
                  this_.$message({
                    message:errmsg,
                    type: 'warning'
                  });
                }
              };
              paramdata.onFailed = function(res) {
                console.log(res);
              };
              this_.$axiosUtil.postServer(paramdata);

            } else {
              console.log('手机号码错误!!');
              this.stepNumber = number-1;
              return false;
            }
          });
        } else {
          this.stepNumber = 1;
        }
      },
      //验证表单
      validateInfo(data_, callback) {
        let this_ = this;
        data_.userId = this_.$store.state.userId; //默认用户id
        let paramdata = {};
        paramdata.url = '/jwt/user/validate';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            if (data_.validateMobile) {
              this_.countdownClickDisabled = false; //手机号码验证通过后允许点击发送验证码
            }
            callback();
          } else {
            let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
            callback(new Error(errmsg));
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      // 获取验证码
      getVerificationCode() {
        //控制不能重复请求
        if (this.countdownClickDisabled) return;
        this.countdownClickDisabled = true;
        let this_ = this;
        var data_ = {
          "systemcode":this.$store.state.systemcode,//系统编号
          "projectno":this.$store.state.projectno,//项目编号
          "mobile": this_.oldMobile ,//手机号码
          "userId": this.$store.state.userId, //当前账号id
          "userName": this.$store.state.user //当前账号昵称
        };
        let paramdata = {};
        paramdata.url = '/jwt/user/sendVerificationCode';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //获取验证码
            this_.countdown();
          } else {
            this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
            this_.$message.error('获取验证码失败原因:' + res.data.errmsg);
          }
        };

        paramdata.onFailed = function(res) {
          this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
        };

        this_.$axiosUtil.postServer(paramdata);

      },
      // 获取验证码倒计时
      countdown() {
        // if(this.countdownClickDisabled)return;
        // this.countdownClickDisabled = true;
        this.countdownTime = this.$store.state.defaultCountdownTime;
        this.verificationMsg = this.countdownTime + 's后重新获取'

        let clock = window.setInterval(() => {

          this.countdownTime--;

          this.verificationMsg = this.countdownTime + 's后重新获取';

          if (this.countdownTime < 0) {

            window.clearInterval(clock);

            this.verificationMsg = '重新获取验证码';

            this.countdownClickDisabled = false;

          }

        }, 1000);
      }
    }
  })
</script>

<style lang="scss" scoped>
  p {
    margin: 0px;
    padding: 0px;
  }

  .changePhoneNumber {
    width: 100%;
    height: 100%;
    background: rgb(244, 245, 246);
  }

  >>>.contair {
    width: 1280px;
    height: calc(100vh - 137px);
    ;
    margin: 0px auto;
    background: #ffffff;
    padding: 20px 20px;
    box-sizing: border-box;
  }

  .title {
    height: 40px;
    width: 1280px;
    margin: 0px auto;
    padding: 8px 0px;
  }

  .title>p {
    font-size: 18px;
    line-height: 40px;
    color: #222;
  }

  >>>.el-step__title.is-process {
    font-weight: normal;
  }

  >>>.el-step__description.is-process {
    color: #444;
  }

  .icon-gantanhao {
    color: $color-primary;
    font-size: 18px;
    vertical-align: 0;
  }

  .stepOne {
    width: 800px;
    margin-left: 300px;
  }

  .phoneNumber {
    display: flex;
    margin-bottom: 10px;
  }

  .phoneInput {
    display: flex;
  }

  .message {
    display: flex;
  }

  .lines {
    height: 1px;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    background: rgb(238, 238, 238);
  }

  .tips {
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    margin-top: 40px;
    margin-bottom: 20px;
    color: #555;
  }

  .leftbox {
    width: 15%;
    font-size: 16px;
    min-height: 1px;
  }

  .leftbox>p {
    line-height: 43px;
    color: #555;
  }

  .rightbox {
    line-height: 43px;
    width: 190px;
  }

  .rightbox>p {
    color: #666;
    padding-left: 5px;
  }

  .sendMessage {
    padding: 0px 15px;
    border: 1px solid $color-primary;
    margin-left: 10px;
    background: $color-primary;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    text-decoration: none;
    color: #fff;
  }

  .sendMessage:hover {
    cursor: pointer;
    background: #f78989;
  }

  .sendMessageDisabled {
    padding: 0px 15px;
    margin-left: 10px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    background: #999;
    color: #fff;
  }




  .message>>>.el-input {
    width: 180px;
  }

  .message>>>.el-input__inner {
    color: #666;
    width: 180px;
    padding-left: 5px;
    border-radius: $border-radius;
  }

  .noSend {
    color: $color-primary;
    line-height: 40px;
    margin-left: 10px;
    height: 40px;
  }

  .btnBox {
    display: flex;
    margin-top: 30px;
  }

  .nextButton {
    color: #ffffff;
    background: $color-primary;
    outline: none;
    border: 1px solid $color-primary;
    padding: 10px 15px;
  }

  .nextButton:hover {
    cursor: pointer;
    background: $color-primary-light-1;
  }

  .sendMessage,
  .noSend {
    cursor: pointer;
  }

  .mailBox {
    margin-left: 10px;
  }

  .mail {
    line-height: 43px;
    color: $color-primary;
  }

  .mail:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/changeEmail.vue